export const TOKEN = '@bamboleio-dashboardreport:access-token'
